import { render, staticRenderFns } from "./PhoneListTab.vue?vue&type=template&id=e055dfee&"
import script from "./PhoneListTab.vue?vue&type=script&lang=js&"
export * from "./PhoneListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports